// extracted by mini-css-extract-plugin
module.exports = {"layout":"video-grid_layout__4YngM","videoContainer":"video-grid_videoContainer__CcvGq"};